import React, { useState, useEffect, useCallback } from 'react';
import { Filter as TelerikFilter } from '@progress/kendo-react-data-tools';
import CustomFilter from './CustomFilter';
import { initialExpression } from './constants';
import filters from './FiltersList';
import sortBy from 'lodash/sortBy';

const Filter = ({
  entity, filterFields, onChange, value, getFilterFields, disableSorting = false,
}) => {
  const [fields, setFields] = useState([]);
  const [expression, setExpression] = useState(value || initialExpression);

  const retrieveFields = useCallback(async () => {
    if (!entity) {
      return;
    }
    const entityFields = await getFilterFields(entity)
      .then((items) => sortBy(items, disableSorting ? '' : 'displayName')
        .map((x) => ({
          name: x.field,
          label: x.displayName,
          operators: filters[x.filterKey].operators(x),
          filter: filters[x.filterKey].component(x),
          required: x.required,
        })));

    setFields(entityFields);

    let defaultFilters = entityFields.filter((e) => e.required).map((entityField) => (
      {
        field: entityField?.name,
        operator: entityField?.operators[0]?.operator,
      }));

    if (defaultFilters.length === 0) {
      defaultFilters = [{
        field: entityFields[0]?.name,
        operator: entityFields[0]?.operators[0]?.operator,
      }];
    }

    if (value?.filters?.length === 0) {
      setExpression({
        ...value,
        filters: [
          {
            logic: 'and',
            filters: defaultFilters,
          },
        ],
      });
    }
  }, [filterFields, entity]);

  useEffect(() => {
    retrieveFields();
  }, [retrieveFields]);

  useEffect(() => {
    setExpression(value);
  }, [value]);

  const handleFilterChange = ({ filter }) => {
    setExpression(filter);
    if (onChange) {
      onChange(filter);
    }
  };

  const oldFilter = () => expression.filters.some((x) => 'operator' in x || x.filters?.some((x) => 'filters' in x));
  const FilterComponent = oldFilter() ? TelerikFilter : CustomFilter;

  return <FilterComponent fields={fields} value={expression} onChange={handleFilterChange} />;
};

export default Filter;
